import React, { useEffect , useState } from 'react';
import { Grid, Segment, Form, Table, Button, Input } from 'semantic-ui-react';
import { Helmet } from 'react-helmet';
import CustomDatePicker from '../_reusables/Datepicker';
// import VendingMachineContainer from '../VMs/container';

const Reporting = ({
  loading,
  dateFrom,
  dateTo,
  changeFrom,
  changeTo,
  stats,
  topSelling,
  tableCount,
  handleShowReport
}) => {
  const [VmID, setVM] = useState("");
  const url = '/VendingMachines/' + VmID +'/reporting'
  if (loading) {
    return (
      <Grid>
        <Grid.Row>
          <Grid.Column>
            <Segment style={{ height: '90vh' }} loading={loading} />
          </Grid.Column>
        </Grid.Row>
      </Grid>
    );
  }

  return (
  
    <Grid centered padded style={{ marginTop: '0px', padding: '10vh' }}>
      <Helmet>
        <title>Vending Machine Report</title>
      </Helmet>
      
      <Grid.Row >
        
        {/* Search Bar for VM Id and Back Button*/}
        <Form>
          <Form.Group widths="equal">
            <Form.Field>
              <Button basic color="blue" style={{marginRight: '50px'}}>
                <a href='/VendingMachines'>Back</a>
              </Button>
            </Form.Field>
            <Form.Field>
            <label style={{ textAlign: 'left', fontWeight:700}}>VM Id</label>
              <Input value={VmID} onChange={(e) => setVM(e.target.value)} style={{marginRight: '100px'}} />
            </Form.Field>
            <Form.Field style={{ paddingTop: '1.7em' }}>
              <Button basic color="blue" >
                <a href= {url}>
                  Get Report
                </a>
              </Button>
            </Form.Field>
          </Form.Group>
        </Form>
      </Grid.Row>
      <Grid.Row centered>
        <Grid.Column width={4}>
          <h2
            style={{
              fontWeight: 400,
              border: '1px solid #555',
              textAlign: 'center',
              color: '#555',
              padding: '0.5em'
            }}
          >
            Vending Machine Report
          </h2>
        </Grid.Column>
      </Grid.Row>
      <Grid.Row centered>
        <Grid.Column width={8}>
          <Segment style={{ paddingTop: '1em' }}>
            <h3 style={{ fontWeight: 400, textAlign: 'center' }}>
              Viewing Report for :{' '}
              <span style={{ fontWeight: 'bold', textDecoration: 'underline' }}>
                {stats ? stats.vmName : 'Unknown'}
              </span>
            </h3>
            <h3 style={{ fontWeight: 400, marginBottom: '1em' }}>Select Date Range</h3>
            <Form>
              <Form.Group widths="equal">
                <Form.Field>
                  <label>Date From : </label>
                  <CustomDatePicker dateValue={dateFrom} onDateChange={changeFrom} />
                </Form.Field>
                <Form.Field>
                  <label>Date To: </label>
                  <CustomDatePicker dateValue={dateTo} onDateChange={changeTo} />
                </Form.Field>
                <Form.Field style={{ paddingTop: '1.7em' }}>
                  <Button basic color="blue" onClick={handleShowReport}>
                    Show Report
                  </Button>
                </Form.Field>
              </Form.Group>
            </Form>
            <hr />
            <br />
            <h3
              style={{
                fontWeight: 400,
                marginBottom: '1em',
                marginTop: '0.5em'
              }}
            >
              Sales Summary
            </h3>
            <Table celled>
              <Table.Body>
                <Table.Row>
                  <Table.Cell>Orders</Table.Cell>
                  <Table.Cell>{stats ? stats.totalOrders : 'N/A'}</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>Orders Value</Table.Cell>
                  <Table.Cell>Rs. {stats ? stats.totalOrderValue : 'N/A'}</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>Avg. Ticket Size</Table.Cell>
                  <Table.Cell>{stats ? stats.avgTicketSize : 'N/A'}</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>Variety of Items Sold</Table.Cell>
                  <Table.Cell>{stats ? stats.itemVariety : 'N/A'}</Table.Cell>
                </Table.Row>
              </Table.Body>
            </Table>
            <br />
            <hr style={{ border: '0.5px solid #555', width: '50%', marginTop: '1em' }} />
            <h3
              style={{
                fontWeight: 400,
                marginBottom: '1em'
              }}
            >
              Top Sold Items
            </h3>
            <Table celled fixed>
              <Table.Header>
                <Table.Row>
                  <Table.HeaderCell>Top 5 Selling Meals</Table.HeaderCell>
                  <Table.HeaderCell>Top 5 Selling Snacks</Table.HeaderCell>
                  <Table.HeaderCell>Top 5 Selling Beverages</Table.HeaderCell>
                </Table.Row>
              </Table.Header>
              <Table.Body>
                {tableCount.map(el => (
                  <Table.Row>
                    <Table.Cell>
                      {topSelling &&
                      topSelling.meals &&
                      topSelling.meals[el] &&
                      topSelling.meals[el].name
                        ? topSelling.meals[el].name
                        : 'N/A'}
                    </Table.Cell>
                    <Table.Cell>
                      {topSelling &&
                      topSelling.snacks &&
                      topSelling.snacks[el] &&
                      topSelling.snacks[el].name
                        ? topSelling.snacks[el].name
                        : 'N/A'}
                    </Table.Cell>
                    <Table.Cell>
                      {topSelling &&
                      topSelling.beverages &&
                      topSelling.beverages[el] &&
                      topSelling.beverages[el].name
                        ? topSelling.beverages[el].name
                        : 'N/A'}
                    </Table.Cell>
                  </Table.Row>
                ))}
              </Table.Body>
            </Table>
            <br />
          </Segment>
          <br />
          <br />
        </Grid.Column>
      </Grid.Row>
    </Grid>
  );
};

export default Reporting;



// WEBPACK FOOTER //
// ./src/Modules/Reporting/component.jsx